// // *******************************************************************************
// // Form handling
// // *******************************************************************************

// const handleForm = (form, formAction) => {
//   const formParent = form.closest('[data-parent]');
//   const formAlertError = formParent.querySelector('.form__alert-error');

//   const fv = FormValidation.formValidation(form, {
//     locale: 'sl_SI',
//     localization: FormValidation.locales.sl_SI,
//     fields: {},
//     plugins: {
//       message: new FormValidation.plugins.Message({
//         container: (field, element) => element.closest('.mod-input,.checkbox'),
//       }),
//       declarative: new FormValidation.plugins.Declarative({
//         html5Input: true,
//       }),
//       trigger: new FormValidation.plugins.Trigger({
//         event: 'submit',
//       }),
//       submitButton: new FormValidation.plugins.SubmitButton(),
//     },
//   })
//     .on('core.element.validated', (e) => {
//       if (e.element.hasAttribute('required')) {
//         const value = fv.getElementValue(e.field, e.element);
//         const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
//         FormValidation.utils.classSet(container, {
//           'is-validation-failed': value === '' || !e.valid,
//         });
//       }
//     })
//     .on('core.form.valid', () => {
//       grecaptcha.ready(async () => {
//         formParent.classList.add('show-loader');
//         try {
//           await onFormSubmit({
//             formData: {
//               ...getFormValue(form, fv),
//               lang: localData.lang,
//               formId: form.getAttribute('id'),
//             },
//             recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
//             recaptchaAction: formAction,
//           });
//           formParent.classList.remove('show-loader');
//           formParent.classList.add('show-thankyou');
//           if (formParent.closest('.form-modal')) {
//             const formModalEle = formParent.closest('.form-modal');
//             formModalEle.classList.add('show-thankyou');
//           }
//         } catch (error) {
//           console.error(error);
//           formParent.classList.remove('show-loader');
//           formParent.classList.add('show-error');
//           formAlertError.classList.remove('hide');
//           formAlertError.innerHTML = error.response.data.data.msg;
//         }
//       });
//     });
// };

// document.addEventListener('DOMContentLoaded', () => {
//   ['newsletter-form', 'newsletter-module-form'].forEach((id) => {
//     const form = document.querySelector(`#${id}`);
//     if (form !== null) {
//       const formAction = form.querySelector('[data-action]').value;
//       handleForm(form, formAction);
//     }
//   });
//   document.querySelectorAll('.mod-input__field').forEach((input) => {
//     input.addEventListener('focus', () => {
//       loadRecaptcha();
//     });
//   });
// });

// const loadRecaptcha = () => {
//   const scripts = document.querySelectorAll('.gcaptcha-script');
//   scripts.forEach((script) => {
//     if (script.type === 'text/plain') {
//       script.type = 'text/javascript';
//       document.head.appendChild(script);
//     }
//   });
// };
